module.exports = __webpack_public_path__ + "img/arrow.ae0da10a.svg";